import * as React from 'react';
import { twMerge } from 'tailwind-merge';

import { WithCommonProps } from '@types';

import { Icon, IconNames, IconSizes } from '@components/icon';
import {
  Tooltip,
  ITooltipProps,
  useHoverableTooltip,
} from '@components/tooltip';

export type IconTooltipProps = WithCommonProps<
  {
    icon: IconNames;
    size?: IconSizes;
    solid?: boolean;
    tooltipId?: string;
  } & Omit<ITooltipProps, 'id' | 'reference' | 'isOpen'>
>;

export function IconTooltip({
  children,
  size,
  icon,
  tooltipId = 'icon-tooltip',
  placement,
  onClickAway,
  solid = false,
  className: classNameProp,
  ...props
}: IconTooltipProps): JSX.Element | null {
  const { triggerProps, opened } = useHoverableTooltip();
  const tooltipRef = React.useRef<HTMLElement>(null);

  return (
    <>
      <i
        className={twMerge('inline-flex', classNameProp)}
        {...triggerProps}
        {...props}
        ref={tooltipRef}
        aria-describedby={tooltipId}
      >
        <Icon size={size} name={icon} solid={solid} />
      </i>
      <Tooltip
        id={tooltipId}
        reference={tooltipRef.current}
        placement={placement}
        onClickAway={onClickAway}
        isOpen={opened}
        className="whitespace-normal max-w-[400px] z-[10000]"
      >
        {children}
      </Tooltip>
    </>
  );
}
